import {
    defaultShouldDehydrateQuery,
    QueryClient,
} from "@tanstack/react-query";
import { cache } from "react";

const getServerQueryClient = cache(() => {
    return makeQueryClient();
});

function makeQueryClient() {
    return new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: 60 * 1000,
                refetchOnWindowFocus: false,
            },
            dehydrate: {
                shouldDehydrateQuery: (query) =>
                    defaultShouldDehydrateQuery(query) ||
                    query.state.status === "pending",
                shouldRedactErrors: () => {
                    return false;
                },
            },
        },
    });
}

let browserQueryClient: QueryClient | undefined = undefined;

export function getQueryClient(client: boolean = true) {
    if (!client) {
        return getServerQueryClient();
    } else {
        if (!browserQueryClient) browserQueryClient = makeQueryClient();
        return browserQueryClient;
    }
}
